import { createAction } from '@reduxjs/toolkit';
const SET_CONTENT_HERO_INDENT = 'GET_CONTENT_HERO_INDENT';
export const setContentHeroIndent = createAction(SET_CONTENT_HERO_INDENT);
export const actions = {
    contentHeroIndent: setContentHeroIndent,
};
